import React, { useRef, useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import "../../ReviewComponents/ABMOfDocuments/ABMOfDocuments.css";

const CreateABM = ({ OpenForm, setTypeDocument, typeDocument }) => {
  const downloadLinkRef = useRef(null);
  const [tipeButtonAMB] = useState({
    viewList: true,
    tipeForm: "Crear",
  });

  const handleClick = (e) => {
    e.preventDefault();
    handlerdowload(e);
    handleCreateClick(e);
  };

  const handlerdowload = async (e) => {
    e.preventDefault();
    OpenForm(tipeButtonAMB);
  };

  const handleCreateClick = (e) => {
    e.preventDefault();
    setTypeDocument(typeDocument);
  };
  return (
    <button
      className="button_abm-lealtad"
      type="button"
      onClick={(e) => handleClick(e)}
      ref={downloadLinkRef}
    >
      <i className="fa fa-refresh-lealtad"></i>
      <AiFillFileAdd className="icon-list-lealtad" />
    </button>
  );
};

export default CreateABM;